
import { css } from 'lit';
export default css`
/* Apply CSS Variables to the host element. */
:host{
  --sic-home-hero--default--subtitle-font-size:var(--body-04-font-size);
  --sic-home-hero--default--subtitle-line-height:var(--body-04-line-height);
}
`;